import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

interface PlatformParams {
  platform?: string;
  platform_mall_id?: string;
}

export function usePlatformParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const platformParams: PlatformParams = useMemo(() => {
    const platform = searchParams.get('platform');
    const platform_mall_id = searchParams.get('platform_mall_id');
    
    const params: PlatformParams = {};
    if (platform) params.platform = platform;
    if (platform_mall_id) params.platform_mall_id = platform_mall_id;
    
    return params;
  }, [searchParams]);

  const createUrlWithParams = (path: string, additionalParams?: Record<string, string>) => {
    const url = new URL(path, window.location.origin);
    
    // 기존 플랫폼 파라미터 추가
    if (platformParams.platform) {
      url.searchParams.set('platform', platformParams.platform);
    }
    if (platformParams.platform_mall_id) {
      url.searchParams.set('platform_mall_id', platformParams.platform_mall_id);
    }
    
    // 추가 파라미터가 있다면 추가
    if (additionalParams) {
      Object.entries(additionalParams).forEach(([key, value]) => {
        url.searchParams.set(key, value);
      });
    }
    
    return url.pathname + url.search;
  };

  const updateParams = (newParams: Partial<PlatformParams>) => {
    const updatedParams = new URLSearchParams(searchParams);
    
    Object.entries(newParams).forEach(([key, value]) => {
      if (value) {
        updatedParams.set(key, value);
      } else {
        updatedParams.delete(key);
      }
    });
    
    setSearchParams(updatedParams);
  };

  return {
    platformParams,
    createUrlWithParams,
    updateParams,
    hasPlatformParams: !!(platformParams.platform || platformParams.platform_mall_id)
  };
}